define([], function() {
    'use strict';
    return function(obj) {
        return obj === void 0;
    };
});
